export interface Classifier {
    id: number;
    parentId: number;
    enabled: boolean;
    name: string;
    description: string;
}

export enum ClassifierType {
    authorityRole = 1,
    groupTypes = 10,
    LangTypes = 19,
}

export enum AuthorityRoles {
    Originator = 101,
    Importer = 102,
    Publisher = 103,
}

export enum UomDimensionTypes {
    M = 1201,
    FT = 1202,
}

export enum AuthorityPurposes {
    Authorization = 1401,
    Notification = 1402,
    Information = 1403,
}

export enum ZoneTypes {
    Prohibited = 301,
    ReqAuthorisation = 302,
    Conditional = 303,
    NoRestriction = 304,
    Uspace = 305,
}

export enum ZoneVariantTypes {
    Common = 201,
    Customized = 202,
}

export enum YesNoType {
    Yes = 401,
    No = 402,
}

export enum InitiatingSystemType {
    DRZ = 1701,
    BGKIS = 1702,
}

export enum ZoneStatusType {
    Draft = 801,
    Submitted = 802,
    ImportApproved = 803,
    ImportDeclined = 804,
    LGSApproved = 805,
    LGSDeclined = 806,
    PublishedEdit = 807,
    BufferZoneGenerated = 808,
    ObjectPartlyAndBufferZonePartlyInBaseGeometry = 809,
    ObjectOutsideAndBufferZonePartlyInBaseGeometry = 810,
    ObjectInsideAndBufferZonePartlyInBaseGeometry = 811,
    ObjectOutsideAndBufferZoneOutsideBaseGeometry = 812,
    CAAUnpublishedEdit = 813,
    UnpublishedEdit = 814,
    BufferZoneSmallerThan200SQM = 815,
    BufferzoneHasAnglesSmallerThan10Degrees = 816,
    CAAArchived = 817,
}
